import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevExtremeModule } from '../devextreme.module';
import { TelegramConnectionsComponent } from './telegram-connections.component';

@NgModule({ imports: [CommonModule, DevExtremeModule], declarations: [TelegramConnectionsComponent], exports: [TelegramConnectionsComponent] })
export class TelegramConnectionsModule {}
